import { Skeleton } from 'antd';

export const Loading = () => <Skeleton active />;
